import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { FiCheckCircle, FiClock, FiXCircle } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { AppBar, APP } from "../../components/mobileUi";
import {
  DesktopBack,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../../components/desktopUi";
import { getTransferTransactionByIdApi } from "../../api/finance.transferTransaction.api";
import { EMP_BASE_PATH } from "../../config";

const TEXT = "#08142D";
const MUTED = "#94A3B8";
const SUBTLE = "#51607B";
const fmtDate = (v) => (v ? moment(v).format("DD/MM/YYYY") : "-");

const statusMeta = (status) => {
  if (status === "APPROVED")
    return { label: "ĐÃ DUYỆT", bg: "#02BB5E", Icon: FiCheckCircle };
  if (status === "REJECTED")
    return { label: "TỪ CHỐI", bg: "#E5484D", Icon: FiXCircle };
  return { label: "ĐANG CHỜ DUYỆT", bg: "#F79D0D", Icon: FiClock };
};

const serviceCode = (d) =>
  (d?.bookingId && d?.booking?.code) ||
  (d?.lockingId && d?.locking?.code) ||
  (d?.salesContractId && d?.salesContract?.code) ||
  d?.ttkq?.code ||
  "";

const Row = ({ label, value, last }) => (
  <Flex
    justify="space-between"
    align="flex-start"
    gap="12px"
    py="18px"
    borderBottom={last ? "none" : "0.5px solid #EEF1F6"}
  >
    <Text fontSize="14px" color={SUBTLE} flex="0 0 42%">{label}</Text>
    <Text fontSize="14px" fontWeight={600} color={TEXT} flex="1" textAlign="right" whiteSpace="pre-line">
      {value !== undefined && value !== null && value !== "" ? String(value) : "-"}
    </Text>
  </Flex>
);

const TransferTransactionDetail = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getTransferTransactionByIdApi(id)
      .then((d) => setData(d))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [id]);

  const meta = data ? statusMeta(data.status) : null;

  const pageBody = (
    <>

      <Box px="16px" pt="16px">
        {loading ? (
          <Flex justify="center" py="60px"><Spinner color={APP.primary200} /></Flex>
        ) : error || !data ? (
          <Flex justify="center" py="60px"><Text fontSize="14px" color={MUTED}>Không tìm thấy phiếu</Text></Flex>
        ) : (
          <Box>
            <Text fontSize="16px" fontWeight={600} color={TEXT}>
              CHUYỂN {data?.type || ""} {serviceCode(data)}
            </Text>
            {meta && (
              <Flex
                mt="12px"
                align="center"
                alignSelf="flex-start"
                display="inline-flex"
                bg={meta.bg}
                borderRadius="100px"
                px="8px"
                py="4px"
                gap="6px"
              >
                <Box as={meta.Icon} fontSize="16px" color="white" />
                <Text fontSize="12px" fontWeight={600} color="white">{meta.label}</Text>
              </Flex>
            )}
            <Box mt="8px">
              <Row label="Nhân viên hiện tại" value={data?.oldEmployee?.fullName} />
              <Row label="Nhân viên mới" value={data?.newEmployee?.fullName} />
              <Row label="Loại" value={data?.type} />
              <Row label="Mã dịch vụ" value={serviceCode(data)} />
              <Row label="Thời gian tạo" value={fmtDate(data?.createdAt)} last />
            </Box>
          </Box>
        )}
      </Box>
    </>
  );

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage title="Chi tiết đơn đăng ký phiếu đăng ký" right={<DesktopBack onClick={() => navigate(-1)} />}>
        <DesktopPanel p="0" pb="24px">
          {pageBody}
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto" bg="white" minH="100dvh">
      <AppBar title="Chi tiết đơn đăng ký phiếu đăng ký" onBack={() => navigate(`${EMP_BASE_PATH}/tai-chinh/chuyen-giao-dich`)} />
      {pageBody}
    </Box>
  );
};

export default TransferTransactionDetail;
